import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../../modules/infra/i18n';
import ReportsFilter from '../../../../main/reports/reportsFilter';

const BulkUpdateFilters = ({
  brandFilters,
  categoryFilters,
  allBrandsChecked,
  allCategoriesChecked,
  onCategoryFilterChange,
  onBrandFilterChange,
  searchText,
  onSearchChange,
}) => (
  <div className="c-report-filters u-mb">
    <div className="c-form-input-group__item u-mr u-pl-- layout__item u-1/3">
      <input
        type="text"
        name="search"
        className="c-input c-input--search"
        value={searchText}
        onChange={onSearchChange}
        placeholder={t('products:bulk_inventory.search_placeholder')}
      />
    </div>
    <div className="c-form-input-group__item u-mr" display-if={brandFilters.length}>
      <ReportsFilter
        title={t('products:bulk_inventory.brands_label')}
        filters={brandFilters}
        updateStatusViewed={onBrandFilterChange}
        allChecked={allBrandsChecked}
        showSelectAll
      />
    </div>
    <div className="c-form-input-group__item" display-if={categoryFilters.length}>
      <ReportsFilter
        title={t('products:bulk_inventory.categories_label')}
        filters={categoryFilters}
        updateStatusViewed={onCategoryFilterChange}
        allChecked={allCategoriesChecked}
        showSelectAll
      />
    </div>
  </div>
);

BulkUpdateFilters.propTypes = {
  brandFilters: PropTypes.array.isRequired,
  categoryFilters: PropTypes.array.isRequired,
  allBrandsChecked: PropTypes.bool.isRequired,
  allCategoriesChecked: PropTypes.bool.isRequired,
  onCategoryFilterChange: PropTypes.func.isRequired,
  onBrandFilterChange: PropTypes.func.isRequired,
  searchText: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
};

export default BulkUpdateFilters;
